module.exports = __webpack_public_path__ + "static/plain-regular-c0fd9aabac4794106316698a59179d83.woff";